var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmissionGassesSeparator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 158,
    viewBox: "0 0 72 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.33959 147.268L0 158L12.567 152.892L8.33959 147.268Z",
    fill: "#206A99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9433 134.881L16.1448 146.657L27.8974 139.871L22.9433 134.881Z",
    fill: "#206A99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8564 120.958L30.0579 132.735L41.8105 125.948L36.8564 120.958Z",
    fill: "#206A99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1534 104.734L42.4126 117.486L52.8691 108.822L47.1534 104.734Z",
    fill: "#206A99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0576 87.8474L53.5679 101.228L62.3874 90.8895L56.0576 87.8474Z",
    fill: "#206A99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7372 69.8347L62.0212 83.4275L69.4105 72.0149L62.7372 69.8347Z",
    fill: "#206A99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0295 50.9634L66.9964 64.4311L71.9999 51.7801L65.0295 50.9634Z",
    fill: "#206A99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1804 33.9759L67.771 44.5064L65.5753 31.0742L59.1804 33.9759Z",
    fill: "#206A99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1045 18.225L59.9814 26.3507L54.608 13.8535L49.1045 18.225Z",
    fill: "#206A99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1584 5.25565L47.2639 11.3848L39.8323 0L35.1584 5.25565Z",
    fill: "#206A99"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmissionGassesSeparator);
export default __webpack_public_path__ + "static/media/emission-gasses-separator.67f80e50bafc5d988cd3322631b4992b.svg";
export { ForwardRef as ReactComponent };